import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from '../meeting/services/util.service';
import { CurrentUser } from '../models/CurrentUser';
import { ExamInfo } from '../models/Exam';
import { CbtserviceService } from '../services/cbtservice.service';
import { ExamService } from '../services/exam.service';
import { ProctoringService } from '../services/proctoring.service';
import { QuestionserviceService } from '../services/questionservice.service';
import { UserauthenticationserviceService } from '../services/userauthenticationservice.service';
import { LanguageService } from '../services/language.service';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-userexaminations',
  templateUrl: './userexaminations.component.html',
  styleUrls: ['./userexaminations.component.css'],
})
export class UserexaminationsComponent implements OnInit, AfterViewInit, OnDestroy {
  exams: ExamInfo[];
  user: CurrentUser = new CurrentUser();
  isloading: boolean;
  interval: any;
  hasloaded: boolean = false;
  isDestroyInterval: boolean;
  constructor(
    public activatedroute: ActivatedRoute,
    public router: Router,
    public examservice: ExamService,
    public toastr: ToastrService,
    private userauth: UserauthenticationserviceService,
    private proctorservice: ProctoringService,
    private questionservice:QuestionserviceService,
    private cbtservice: CbtserviceService, private languageService: LanguageService, private loadingService: LoadingService) { }
    get language() {
      return this.languageService.language;
    }

  async ngOnInit() {
    //debugger;
    const langCode = this.languageService.getLanguageCode();
    
    localStorage.clear();

    this.questionservice.clearSubmissionQueue();
    //this.questionservice.previousquestiondata = null;
    //this.questionservice.nextquestiondata = null;
    this.isloading = true;
    this.loadingService.show();
    try{
      this.user = await this.userauth.getCurrentUser();
    }
    catch(err){
      throw err;
    } finally {
      // this.isloading = false;
      // this.loadingService.hide();
    }
    this.languageService.setLanguageCodeToCookie(langCode);

    let candidateno = this.user.username;
    //await this.proctorservice.stopProctor(); //just in case
    await this.getuserexams(candidateno);

    this.hasloaded = true;
    this.interval = setInterval(() => { this.getuserexams(candidateno, false); }, 60000);

  }
  
  async getuserexams(candidateno: any, showLoadingOverlay: boolean = true) {
    if (showLoadingOverlay) {
      this.isloading = true;
      this.loadingService.show();
    }
    try{
      this.exams = await this.examservice.getuserexams(candidateno);
    }
    catch(err){
      this.cbtservice.showHttpError(err)
    }
    finally {
      if (showLoadingOverlay) {
        this.isloading = false;
        this.loadingService.hide();
      }
    }
  }

  async ngAfterViewInit() {
    //debugger;

    //no need to await the below
    await this.proctorservice.stopProctor('User exams after view init'); //just in case
    if (!this.activatedroute.snapshot.queryParams.skipMediaTest) {
      await this.proctorservice.startProcteeTestVideo();
    }
  }

  ngOnDestroy() {
    if (this.interval) {
      //debugger;
      clearInterval(this.interval);
      this.interval = undefined;
    }
  }

  destroyInterval(isDestroyInterval: boolean) {
    //debugger;
    clearInterval(this.interval);
    this.interval = undefined;
  }
  resumeInterval(e) {
    if (!this.interval) {
      this.interval = setInterval(() => { this.getuserexams(this.user.username, false); }, 60000);
    }
  }

  trackByScheduleId(index: number, exam: ExamInfo) {
    return exam.scheduleid;
  }
}
